import BucketsPricingModelService from "./buckets-pricing-model-service";
import PricingVersions from "/constants/pricing-versions";

export const getPricingModelService = (pricingVersion) => {
  const pricingModelsModelsMapping = {
    [PricingVersions.VERSION_9]: BucketsPricingModelService
  };

  const PricingModelService =
    pricingModelsModelsMapping[pricingVersion] || pricingModelsModelsMapping[PricingVersions.DEFAULT_VERSION];
  return new PricingModelService();
};

export const getPricingVersion = ({
  forcePricing,
  res,
  cookies = {},
  abTests = [],
  sendBigBrainEvent = false
} = {}) => {
  // add logic here to override the shown pricing version (e.g. cookie-based or forcePricing-based)
  return PricingVersions.DEFAULT_VERSION;
};
